import { type ReactNode } from 'react'
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

interface CommandDeckProps {
  children: ReactNode
  intelligenceOpen: boolean
}

export function CommandDeck({ children, intelligenceOpen }: CommandDeckProps) {
  return (
    <main
      className={cn(
        'flex-1 bg-ark-void overflow-hidden transition-all duration-500 ease-ark relative',
        intelligenceOpen ? 'mr-72' : 'mr-0'
      )}
    >
      <div className="h-full w-full overflow-auto">
        {children}
      </div>
    </main>
  )
}
